import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/question.png'


const _withScopeId = n => (_pushScopeId("data-v-4c19cbfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync-btn flex-ter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))

import { t } from '@/plugins/i18n'
import { syncAllGoods } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [syncLoading, syncApi] = useRequest(syncAllGoods)
const setSyncProduct = async () => {
  const unbind = await confirmApiUnbind()
  if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('同步成功'))
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      style: {"margin-left":"6px"},
      type: "primary",
      loading: _unref(syncLoading),
      onClick: setSyncProduct
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('同步商品信息')), 1)
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_tooltip, {
      content: _unref(t)('同步已授权的店铺内商品，并进行绑定'),
      effect: "light",
      placement: "top-start"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})